//
//  Import classy v2 js from node_modules
//

import '../../../../node_modules/@bankrate/classy-core/dist/js/classy'
